module.exports = __webpack_public_path__ + "img/Butterfly.b32edc00.svg";